import { MATCH_URL_YOUTUBE } from 'shared/embedHelpers';
import { IFrameProps } from 'shared/types';
import { ENV } from 'shared/ENV';
import { Capacitor } from '@capacitor/core';

export const YouTubeIFrame = (props: IFrameProps): JSX.Element => {
  const { src, containerWidth, ...iframeProps } = props;
  const [, videoId] = src.match(MATCH_URL_YOUTUBE) ?? [];
  const encodedVideoId = videoId ? encodeURIComponent(videoId) : '';

  const youtubeProxyUrl = new URL(
    `youtube-embed-proxy.html?videoId=${encodedVideoId}`,
    ENV.VITE_BASE_WEB_URL,
  ).toString();
  const youtubeEmbedUrl = `https://www.youtube.com/embed/${encodedVideoId}?playsinline=1&rel=0&modestbranding=1`;

  let embedSrc = 'about:blank';
  if (encodedVideoId) {
    // iOS WebView can fail direct YouTube iframe usage due to cross-origin/protocol
    // constraints. Route through our hosted proxy page to keep a stable HTTPS origin.
    // Reference: https://github.com/ionic-team/capacitor/issues/8205
    embedSrc =
      Capacitor.getPlatform() === 'ios' ? youtubeProxyUrl : youtubeEmbedUrl;
  }

  return (
    <iframe
      src={embedSrc}
      {...iframeProps}
      allowFullScreen
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      title="YouTube Video"
      scrolling="no"
    />
  );
};
